module.exports = __webpack_public_path__ + "img/3-gray-cartoon.84774813.png";